module.exports = __webpack_public_path__ + "static/media/storefront_wordmark.a2ef23f3.svg";